var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},[React.createElement("title",{"key":0},"background"),React.createElement("rect",{"fill":"none","id":"canvas_background","height":"32","width":"32","y":"-1","x":"-1","key":1})]),React.createElement("g",{"key":1},[React.createElement("title",{"key":0},"Layer 1"),React.createElement("path",{"id":"svg_1","fillRule":"evenodd","fill":"#fa104d","d":"m28.75,26.875l-13.75,-23.75l-13.75,23.75l27.5,0zm-15,-3.75l0,-2.5l2.5,0l0,2.5l-2.5,0zm0,-5l2.5,0l0,-5l-2.5,0l0,5z","clipRule":"evenodd","key":1})])]);
}

Alert.defaultProps = {"width":"30","height":"30"};

module.exports = Alert;

Alert.default = Alert;
